/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-this-alias */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component } from 'react';

import styled from 'styled-components';

import Truncate from './Truncate';

const Anchor = styled.span`
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

type Props = {
  children: any;
  lines: number;
  more: React.ReactNode;
  less: React.ReactNode;
  anchorClass?: string;
  className: string;
  onClick: (truncated: boolean, param: any) => void;
  expanded: boolean;
  width: number;
  keepNewLines: boolean;
  truncatedEndingComponent: React.ReactNode;
  expandByClick: boolean;
  onTruncate?: () => void;
};

type State = {
  expanded: boolean;
  truncated: boolean;
};

class ShowMoreText extends Component<Props, State> {
  _isMounted = false;
  truncateRef = null;

  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      truncated: false,
    };
  }

  static defaultProps = {
    lines: 3,
    more: 'Show more',
    less: 'Show less',
    onClick: undefined,
    expanded: false,
    width: 0,
    keepNewLines: false,
    truncatedEndingComponent: '... ',
    expandByClick: true,
    onTruncate: undefined,
  };

  componentDidMount() {
    this._isMounted = true;

    const _self = this;
    if (this._isMounted) {
      this.setState({
        expanded: _self.props.expanded,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleTruncate = (truncated) => {
    if (this._isMounted && truncated !== this.state.truncated) {
      this.setState({
        truncated,
      });
      if (truncated) {
        this.truncateRef.onResize();
      }
      this.props.onTruncate?.();
    }
  };

  toggleLines = (event) => {
    event.preventDefault();
    const _self = this;

    if (!_self.props.expandByClick) {
      if (_self.props.onClick) {
        _self.props.onClick(_self.state.expanded, event);
      }

      return;
    }

    if (this._isMounted) {
      this.setState(
        {
          expanded: !this.state.expanded,
        },
        () => {
          if (_self.props.onClick) {
            _self.props.onClick(_self.state.expanded, event);
          }
        }
      );
    }
  };

  render() {
    const {
      children,
      more,
      less,
      lines,
      anchorClass,
      className,
      width,
      keepNewLines,
      truncatedEndingComponent,
    } = this.props;

    const { expanded, truncated } = this.state;

    return (
      <div className={className}>
        <Truncate
          width={width}
          lines={!expanded && lines}
          ellipsis={
            <span>
              {truncatedEndingComponent}
              <Anchor className={anchorClass} onClick={this.toggleLines}>
                {more}
              </Anchor>
            </span>
          }
          onTruncate={this.handleTruncate}
          ref={(ref) => (this.truncateRef = ref)}
        >
          {keepNewLines
            ? children.split('\n').map((line, i, arr) => {
                line = <span key={i}>{line}</span>;

                if (i === arr.length - 1) {
                  return line;
                } else {
                  return [line, <br key={i + 'br'} />];
                }
              })
            : children}
        </Truncate>
        {!truncated && expanded && (
          <span>
            {' '}
            <Anchor className={anchorClass} onClick={this.toggleLines}>
              {less}
            </Anchor>
          </span>
        )}
      </div>
    );
  }
}

export default ShowMoreText;
